import { API_BASE } from "../../config.js";
import { state } from "../../state/store.js";
import { logout } from "./auth-state.js";

export async function apiFetch(path, options = {}) {
  const url = `${API_BASE}${path}`;
  const headers = Object.assign({ "Content-Type": "application/json" }, options.headers || {});
  if (state.authToken) headers.Authorization = `Bearer ${state.authToken}`;

  let response;
  try {
    response = await fetch(url, { ...options, headers });
  } catch (err) {
    throw new Error(describeNetworkError(err, url));
  }

  if (!response.ok) {
    let detail = `${response.status}`;
    try {
      const data = await response.json();
      detail = data?.detail || detail;
    } catch (_) { /* noop */ }
    if (response.status === 401 && isCrmAuthFailure(detail)) {
      logout({ silent: true });
      throw new Error("Sessao expirada. Entre novamente.");
    }
    throw new Error(detail);
  }
  if (response.status === 204) return null;
  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) return null;
  return await response.json();
}

function isCrmAuthFailure(detail) {
  return /^(missing token|invalid token|user not found)$/i.test(String(detail || "").trim());
}

function describeNetworkError(err, url) {
  const message = String(err?.message || err || "");
  const host = String(url).replace(/^https?:\/\//, "").split("/")[0] || "API";
  const isNetwork = err instanceof TypeError || /Failed to fetch|Load failed|NetworkError/i.test(message);
  return isNetwork
    ? `Nao foi possivel conectar a ${host}. Verifique sua internet, proxy ou firewall.`
    : message || "Falha ao conectar com a API.";
}
